module.exports = __webpack_public_path__ + "images/blue.44c55bab87ac801a6b7bac3741c5c0ce.png";